import { useState, useId as reactUseId } from 'react'

const generateId = (): string => Math.random().toString(36).substr(2, 9)

const useIdFallback = (passedId?: string): string => {
  const [id] = useState(passedId || generateId)
  return id
}

const useId = (passedId?: string): string => {
  if (reactUseId && typeof reactUseId === 'function') {
    return passedId || reactUseId()
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- it's a fallback for environments where useId is not available
  return useIdFallback(passedId)
}

export default useId
